import { render, staticRenderFns } from "./update.vue?vue&type=template&id=f1367c88&scoped=true&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"
import style0 from "./update.vue?vue&type=style&index=0&id=f1367c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1367c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1367c88')) {
      api.createRecord('f1367c88', component.options)
    } else {
      api.reload('f1367c88', component.options)
    }
    module.hot.accept("./update.vue?vue&type=template&id=f1367c88&scoped=true&", function () {
      api.rerender('f1367c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/update.vue"
export default component.exports